<app-page-loader *ngIf="showLoader"></app-page-loader>
<marquee direction="right" class="bg-warning" *ngIf="noti.active"><h5 class="m-0 text-black">{{noti.dtlAlert}}</h5></marquee>
<router-outlet></router-outlet>
<button type="button" class="btn btn-sm btn-sky-blue btn-floating-right d-block d-ms-block d-md-block d-lg-none" *ngIf="isShow" (click)="gotoTop()">
  <i class="fas fa-arrow-up"></i>
  <p class="font-size m-0">{{'BUTTON.TO_TOP'|translate}}</p>
</button>